import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { InboundEmailAddressesRoute } from '../../routing'

export class InboundEmailAddressesPage extends Component {
    render() {
        return (
            <Fragment>
                <Breadcrumbs />
                <InboundEmailAddressesRoute />
            </Fragment>
        )
    }
}
